import { render } from "./ModalRename.vue?vue&type=template&id=cfa9b7f6&scoped=true"
import script from "./ModalRename.vue?vue&type=script&lang=js"
export * from "./ModalRename.vue?vue&type=script&lang=js"

import "./ModalRename.vue?vue&type=style&index=0&id=cfa9b7f6&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa9b7f6"]])

export default __exports__